import Vue from 'vue'

import WysiwygMixin from '../wysiwyg_mixin'
import ModalMixin from '../modal_mixin'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'

locale.use(lang)

export default (data) => {

  // Summernote用の設定
  data.uploadImageUrl = '/admin/news/upload_img'
  data.uploadFileUrl = '/admin/news/upload_img'
  data.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content
  data.errors = data.errors || {}
  // WYSIWYGミックスイン用の初期値
  data.wysiwygSelectedFileName = data.wysiwygSelectedFileName || null

  data.disabled = data.mode === 'show'

  const vm = new Vue({
    el: '#privacy-policy-content',
    mixins: [WysiwygMixin, ModalMixin],
    data() {
      return data;
    },
    mounted() {
      // Summernoteを初期化
      this.$nextTick(() => {
        this.initSummernote('#wysiwyg_editor', {
          styleTags: ['p', 'h2', 'h3', 'h4'],
          styleLabels: {
            p: '標準',
            h2: 'ヘッダー2',
            h3: 'ヘッダー3',
            h4: 'ヘッダー4',
          },
          hideButtons: ['customPicture', 'uploadFile']
        })
      })
      
      if (data.disabled) {
        $(':input').prop('disabled', true);
        $('input[type="button"],button[type="button"]').prop('disabled', false);
      }
    },
    methods: {
      saveContent() {
        // Summernoteのコンテンツをクリーンアップして保存
        if (this.editor) {
          // Vueモデルとtextareaに反映
          const cleanedContent = this.getCleanContent()
          this.policy.contents = cleanedContent
          this.editor.summernote('code', cleanedContent)
        }
      },
      updateComment(contents) {
        // WYSIWYGエディタの内容をVueモデルに反映
        this.policy.contents = contents
      },
    }
  })
}
